const style = theme => ({
  card: {
    position: 'relative',
  },
  ribbon: {
    width: '150px',
    height: '150px',
    overflow: 'hidden',
    position: 'absolute',
    top: -10,
    right: -10,
    '&:before': {
      boxSizing: 'content-box',
      borderRightColor: 'transparent',
      borderTopColor: 'transparent',
      top: 0,
      left: 0,
      position: 'absolute',
      zIndex: -1,
      content: '',
      display: 'block',
      border: '5px solid #2980b9',
    },
    '&:after': {
      borderRightColor: 'transparent',
      borderTopColor: 'transparent',
      top: 0,
      left: 0,
      position: 'absolute',
      zIndex: -1,
      content: '',
      display: 'block',
      border: '5px solid #2980b9',
    },
  },
  ribbonContent: {
    left: '-25px',
    top: '30px',
    webkitTransform: 'rotate(45deg)',
    msTransform: 'rotate(45deg)',
    transform: 'rotate(45deg)',
    position: 'absolute',
    display: 'block',
    width: '225px',
    padding: '15px 0',
    backgroundColor: '#3498db',
    boxShadow: '0 5px 10px rgba(0,0,0,.1)',
    color: '#fff',
    textShadow: ' 0 1px 1px rgba(0,0,0,.2)',
    textAlign: 'center',
  },
})

export default style
